import React from 'react'
import SearchButton from './SearchButton'
import Button from '../../ui/button/Button'
import { BoxIcon, Plus } from 'lucide-react'

interface DefaultTableHeaderProps {
    handleChange: (value: string) => void
    handleCreate?: () => void
}

const DefaultTableHeader = ({ handleChange, handleCreate }: DefaultTableHeaderProps) => {
    return (
        <>
            {/* PC */}
            <div className='hidden md:flex inset-0 items-center justify-between gap-2'>
                <div className='py-1 font-bold text-gray-500 text-start text-theme-xs dark:text-gray-400'>
                    <SearchButton handleChange={handleChange} />
                </div>

                {handleCreate && (
                    <Button size='sm' variant='primary' startIcon={<Plus className='w-4 h-4' />} onClick={handleCreate}>
                        Adicionar
                    </Button>
                )}
            </div>

            {/* Mobile */}
            <div className='md:hidden flex items-center justify-between gap-1'>
                <SearchButton handleChange={handleChange} />
                {handleCreate && (
                    <Button size='sm' variant='primary' onClick={handleCreate}>
                        <Plus />
                    </Button>
                )}
            </div>
        </>
    )
}

export default DefaultTableHeader
